import React from 'react';

import { IRequestStatus } from '../../declarations';
import AccountLoginForm from './AccountLoginForm';
import AccountRegistrationForm from './AccountRegistrationForm';

import './LoginOrRegisterBoxStyle.less';

export interface ILoginOrRegisterBoxProps {
  email?: string;
  emailAlreadyRegistered?: boolean;
  loginRequestStatus: IRequestStatus;
  loginHeaderText?: string;
  name?: string;
  phone?: string;
  onLoginSubmit: (email: string, password: string, rememberMe: boolean) => void;
  onRegistrationSubmit: (
    email: string,
    name: string,
    password: string,
    phone: string,
    rememberMe: boolean,
  ) => void;
  registrationHeaderText?: string;
  registrationRequestStatus: IRequestStatus;
  verifyEmail?: boolean;
}

export default class LoginOrRegisterBox extends React.PureComponent<ILoginOrRegisterBoxProps> {
  public static defaultProps: Partial<ILoginOrRegisterBoxProps> = {
    emailAlreadyRegistered: false,
    loginHeaderText: 'Sign in to Opendoor',
  };

  public render() {
    const {
      email,
      emailAlreadyRegistered,
      loginHeaderText,
      loginRequestStatus,
      name,
      phone,
      onLoginSubmit,
      onRegistrationSubmit,
      registrationHeaderText,
      registrationRequestStatus,
      verifyEmail,
    } = this.props;

    const registrationForm = (
      <div
        className={`col-md-6 col-xs-12 ${emailAlreadyRegistered ? '' : 'first-box'}`}
        key="registration-form"
      >
        <AccountRegistrationForm
          email={emailAlreadyRegistered ? undefined : email}
          loading={registrationRequestStatus.isLoading}
          headerText={registrationHeaderText}
          name={name}
          phone={phone}
          onSubmit={onRegistrationSubmit}
          registrationError={registrationRequestStatus.error}
          verifyEmail={verifyEmail}
        />
      </div>
    );

    const loginForm = (
      <div
        className={`col-md-6 col-xs-12 ${emailAlreadyRegistered ? 'first-box' : ''}`}
        key="login-form"
      >
        <AccountLoginForm
          email={email}
          loading={loginRequestStatus.isLoading}
          loginError={loginRequestStatus.error}
          headerText={loginHeaderText}
          onSubmit={onLoginSubmit}
        />
      </div>
    );

    const content = [registrationForm, loginForm];

    if (emailAlreadyRegistered) {
      content.reverse();
    }

    return <div className="login-or-register-box row">{content}</div>;
  }
}
